



































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import viewModelDebugMixin from '@root/common/mixins/viewmodel-debug';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
import { Getter } from 'vuex-class';
import { tableColums } from './table-colums';
// 导入字典
import { dictIsAlonePayMap, dictAlonePayMap, dictIsNoCarMap } from '@/types/parking-lot-management/dictionaries';

import { AREA_LIST_CREATE, AREA_LIST_EDIT } from '../router-names';
// axios请求
import { queryAreaList, exportAreaList, deleteArea } from '@/api/parking-lot-management/index';

@Component({
  name: 'AreaList',
  components: {
    ParkingLotSearch
  }
})
export default class AreaList extends Mixins(TableMixin, TableWidthMixin, viewModelDebugMixin) {
  parkId = ''; // 车场ID,多个车场ID逗号分隔
  parkIds = [];
  areaName = ''; // 区域名称
  areaId = ''; // 区域编号
  isZeroAllowedEnter = '';
  unauthorizedEnter = '';

  tableLoading = false;
  tableData: any[] = []; // 表数据
  sumRowData = {}; // 合计数据
  plateNumOrderBy = '';
  sparePlateNumOrderBy = '';

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '区域名称',
        dataIndex: 'areaName',
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '区域总车位',
        dataIndex: 'plateNum',
        width: 160,
        sortable: true,
        customRender: (text: any) => text || '--'
      },
      {
        title: '产权车位数',
        dataIndex: 'fixedNum',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '长租车位数',
        dataIndex: 'monthNum',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '临停车位数',
        dataIndex: 'tempNum',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '区域剩余车位',
        dataIndex: 'sparePlateNum',
        width: 120,
        sortable: true,
        // scopedSlots: { customRender: 'areaSurNum' },
        customRender: (text: any, record: any) =>
          'areaSurNum' in record ? record.areaSurNum : record.sparePlateNum || '-'
      },
      // {
      //   title: '是否独立计费',
      //   dataIndex: 'alonePay',
      //   width: 110,
      //   customRender: (text: any) => dictAlonePayMap[text],
      // },
      {
        title: '满位是否允许进入',
        dataIndex: 'isZeroAllowedEnter',
        width: 140,
        // customRender: (text: any) => dictAlonePayMap[text],
        customRender: (text: any) => text || '--'
      },
      // {
      //   title: '非授权车辆是否禁入',
      //   dataIndex: 'unauthorizedEnter',
      //   width: 160,
      //   customRender: (text: any) => text || '--',
      // },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 120,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  // 满位是否允许进入
  isAllCommingOptions: IOption[] = Utils.toLabelVal(dictIsNoCarMap);
  // 非授权车辆是否禁入
  unauthorizedOptions: IOption[] = Utils.toLabelVal(dictIsAlonePayMap);

  // @Getter('dictionaries/orderPayMethod')
  // orderPayMethod?: object
  // get payMethodsList() {
  //   return Utils.toLabelVal(this.orderPayMethod)
  // }

  /**
   * 生命周期钩子函数
   */
  created() {
    // 区域信息列表初始化
    this.fetchTableData();
  }

  /**
   * method
   */
  /**
   * 请求列表数据
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { data } = await queryAreaList({
        parkId: this.parkIds.join(','),
        areaId: this.areaId,
        // ...this.searchForm,
        areaName: this.areaName,
        isZeroAllowedEnter: this.isZeroAllowedEnter,
        unauthorizedEnter: this.unauthorizedEnter,
        currPage: this.current,
        pageSize: this.pageSize,
        plateNumOrderBy: this.plateNumOrderBy,
        sparePlateNumOrderBy: this.sparePlateNumOrderBy
      });
      const { datas, totalNum, totalPage, currPage, pageSize, total } = data;
      // const { datas = [], totalNum = 0 } = data || {}
      this.tableData = datas;
      this.sumRowData = {
        fixedNum: total.fixedNumTotal,
        monthNum: total.monthNumTotal,
        plateNum: total.plateNumTotal,
        sparePlateNum: total.sparePlateNumTotal,
        tempNum: total.tempNumTotal
      };
      this.total = totalNum - 0;
      this.current = currPage - 0;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * 查询条件清空
   */
  clear({ defaultParkIdList }) {
    // TODO
    this.parkId = '';
    this.parkIds = defaultParkIdList;
    this.areaName = '';
    this.isZeroAllowedEnter = '';
    this.unauthorizedEnter = '';
    this.fetchTableData(true);
  }
  /**
   * 删除项
   */
  async toDelete(row: any) {
    const { areaId, parkId, propertyNum, monthNum, tempNum, fixedNum } = row;
    try {
      //
      const { status, data, msg, code } = await deleteArea({
        areaId,
        parkId,
        propertyNum: fixedNum || '0',
        monthNum: monthNum || '0',
        tempNum: tempNum || '0'
      });
      // console.log(data)

      if (status === '9999') {
        this.$message.success('删除成功');
        this.fetchTableData();
      } else {
        this.$message.error('删除失败');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '删除失败');
    }
  }

  /**
   * 新增跳转
   */
  toCreate() {
    this.$router.push({
      name: AREA_LIST_CREATE
    });
  }

  /**
   * 编辑跳转
   */
  toEdit(areaId: string) {
    this.$router.push({
      name: AREA_LIST_EDIT,
      params: {
        areaId
      }
    });
  }

  /**
   * 表头筛选
   */
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
}
